import { t } from 'i18next';
import { useSetAtom } from 'jotai';
import _ from 'lodash';

import { Option } from '@/lib/v2/components';

import {
  atomConditionsValues,
  ConditionState,
} from '@/src/modules/AutomationModuleNew/atoms/flows';
import {
  BELONG,
  NOT_BELONG,
  TYPE_GROUPS,
  TYPE_TAGS,
} from '@/src/modules/AutomationModuleNew/constants/flows';

export const selectTypesOptions: Option[] = [
  {
    id: TYPE_GROUPS,
    name: t('useBinaryConditional.group') as unknown as string,
    value: TYPE_GROUPS,
  },
  {
    id: TYPE_TAGS,
    name: t('useBinaryConditional.tag') as unknown as string,
    value: TYPE_TAGS,
  },
];

export const selectBelongOptions: Option[] = [
  {
    id: BELONG,
    name: t('useBinaryConditional.belongs') as unknown as string,
    value: BELONG,
  },
  {
    id: NOT_BELONG,
    name: t('useBinaryConditional.notBelong') as unknown as string,
    value: NOT_BELONG,
  },
];

export const useBinaryConditional = (index: number) => {
  const setConditionsValues = useSetAtom(atomConditionsValues);

  const handleSelectTypeChange = (option: Option | Option[]) => {
    if (Array.isArray(option)) return;

    setConditionsValues((prev) => {
      const newConditions = _.cloneDeep(prev);
      const newCondition: ConditionState = {
        ...newConditions[index],
        selectTypeValue: option,
        selectIdsValues: [],
      };
      newConditions[index] = newCondition;
      return newConditions;
    });
  };

  const handleSelectBelongChange = (option: Option | Option[]) => {
    if (Array.isArray(option)) return;

    setConditionsValues((prev) => {
      const newConditions = _.cloneDeep(prev);
      const newCondition: ConditionState = {
        ...newConditions[index],
        selectBelongValue: option,
      };
      newConditions[index] = newCondition;
      return newConditions;
    });
  };

  const handleSelectIdsChange = (option: Option | Option[]) => {
    if (!Array.isArray(option)) return;

    setConditionsValues((prev) => {
      const newConditions = _.cloneDeep(prev);
      const newCondition: ConditionState = {
        ...newConditions[index],
        selectIdsValues: option,
      };
      newConditions[index] = newCondition;
      return newConditions;
    });
  };

  return {
    handleSelectTypeChange,
    handleSelectBelongChange,
    handleSelectIdsChange,
    selectTypesOptions,
    selectBelongOptions,
  };
};
